<div class="app-shell">
  <div *ngIf="isLoading" class="loader-container">
    <mat-spinner></mat-spinner>
  </div>

  <div
    #content
    id="content"
    class="content"
    [ngStyle]="{
      overflow: !isFirstLogin && preventShoping ? 'hidden' : 'auto'
    }"
    *ngIf="!isLoading"
    (scroll)="onScroll($event)"
    cdkScrollable>
    <app-web-header
      *ngIf="showHeader"
      class="header"
      [shopHeader]="shopHeader"
      [pageHeader]="pageHeader"
      [noShadow]="noShadow"></app-web-header>
    <div *ngIf="isOpeningFirstPage" class="loader-container">
      <mat-spinner></mat-spinner>
    </div>
    <router-outlet class="main-content"></router-outlet>
    <app-web-footer *ngIf="showFooter"></app-web-footer>
  </div>
</div>
<div
  class="back-arrow-container"
  *ngIf="showScrollToTopButton"
  (click)="scrollToTop()">
  <mat-icon svgIcon="arrow-icon" class="arrow-icon"></mat-icon>
</div>
